export const delimiter = ';';
/**
 * @deprecated used in getDefaultAccountImportColumns which is deprecated and should be removed with CNEO-5510
 * TODO: CNEO-5510 Should be removed since backend import is being used now. Keeping it for
 * backwards compitability due to onExtendedAccountImportColumns callback. Should only use import setting here.
 * */
export const getValue = (value) => (value ? value.trim() : '');
/**
 * @deprecated used in getDefaultAccountImportColumns which is deprecated and should be removed with CNEO-5510
 * TODO: CNEO-5510 Should be removed since backend import is being used now. Keeping it for
 * backwards compitability due to onExtendedAccountImportColumns callback. Should only use import setting here.
 * */
export const getArrayValue = (value) => value && value.trim()
    ? value
        .split(delimiter)
        .map(getValue)
        .filter((value) => !!value)
    : [];
